import { render } from "./taskrecursiontree.vue?vue&type=template&id=425249dc&scoped=true"
import script from "./taskrecursiontree.vue?vue&type=script&lang=js"
export * from "./taskrecursiontree.vue?vue&type=script&lang=js"

import "./taskrecursiontree.vue?vue&type=style&index=0&id=425249dc&scoped=true&lang=scss"

import exportComponent from "D:\\startup\\gtdhtml5\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425249dc"]])

export default __exports__